export default __webpack_public_path__ + "static/media/envelope.9284f95a.svg";